// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}

input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6px;
}

.part_orderlist_dropdown_label {
  position: absolute;
  top: -0.2rem !important;
  z-index: 1;
  left: -0.4em !important;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

.status_label {
  top: -10px !important;
  left: 14px !important;
}

.multiSelect_orderlist {
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.select-wrapper {
  position: relative;
  display: block;
}

.input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}

select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}

.pgmtextfield_textfieldcontainers {
  display: flex;
  justify-content: space-between;
  width: 97%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: auto;
  margin-bottom: 1rem;
  padding: 0.6rem;
}
.pgmtextfield_textfieldcontainers .order-date-filter {
  display: flex;
  align-items: center;
  width: 50%;
}

.parts_textfield_dropdown {
  width: 100%;
}

.search_partorderlist::placeholder {
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
}

.partsorderfield_dropdown {
  width: 50%;
}

.buttonsearch::placeholder {
  font-family: "Nunito" !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #A3AEC4 !important;
}

.multiselect_orderstatus {
  width: 100%;
  margin-left: 10px;
}

.multiselect_orderstatus fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}

.multipleselect_order {
  height: 2.5rem;
  width: 160px !important;
}

.multiselect_orderinput {
  min-width: 80% !important;
}

.button_search:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}

@media screen and (max-width: 768px) {
  .pgmtextfield_textfieldcontainers {
    justify-content: flex-start !important;
    flex-wrap: wrap;
  }
  .pgmtextfield_textfieldcontainers .order-date-filter {
    width: 100% !important;
  }
  .multiSelect_orderlist {
    width: 50%;
  }
  .multipleselect_order {
    width: 95% !important;
  }
}
@media screen and (max-width: 480px) {
  .part_order_textfield {
    display: flex;
  }
  .part_order_textfield .parts_textfield_dropdown .input-wrapper {
    width: 100% !important;
  }
  .partlist_containers .button_search {
    width: 95% !important;
    margin: auto;
  }
  .multiSelect_orderlist, .partsorderfield_dropdown {
    width: 100% !important;
  }
  .pgmtextfield_textfieldcontainers .order-date-filter {
    width: 96% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PartsOrderTextfieldComponent/Ordertextfield.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AACF;;AACA;EACE,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AAAA;EACE,qBAAA;EACA,qBAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAIF;;AADA;EACE,kBAAA;EACA,cAAA;AAIF;;AADA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAIF;;AADA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAIF;;AADA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAIF;AAFE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAIJ;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAGF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,iBAAA;AAEF;;AACA;EACE,yBAAA;EACA,kBAAA;AAEF;;AACA;EACE,cAAA;EACA,uBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,mEAAA;AAEF;;AACA;EACE;IACE,sCAAA;IACA,eAAA;EAEF;EACA;IACE,sBAAA;EACF;EAEA;IACE,UAAA;EAAF;EAGA;IACE,qBAAA;EADF;AACF;AAIA;EACE;IACE,aAAA;EAFF;EAMA;IACE,sBAAA;EAJF;EAOA;IACE,qBAAA;IACA,YAAA;EALF;EAQA;IACE,sBAAA;EANF;EASA;IACE,qBAAA;EAPF;AACF","sourcesContent":[".input-wrapper {\n  position: relative;\n}\n\ninput {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  width: 92%;\n  height: 2.3rem;\n  margin: 10px;\n  line-height: 6px;\n}\n.part_orderlist_dropdown_label {\n  position: absolute;\n  top: -0.2rem !important;\n  z-index: 1;\n  left: -0.4em !important;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n\nlabel {\n  position: absolute;\n  top: 0.2ex;\n  z-index: 1;\n  left: 2em;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n.status_label{\n  top: -10px !important;\n  left: 14px !important;\n}\n.multiSelect_orderlist{\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n}\n\n.select-wrapper {\n  position: relative;\n  display: block;\n}\n\n.input::placeholder {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  color: #10132e;\n}\n\nselect {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 94%;\n  height: 2.5rem;\n}\n\n.pgmtextfield_textfieldcontainers {\n  display: flex;\n  justify-content: space-between;\n  width: 97%;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  margin: auto;\n  margin-bottom: 1rem;\n  padding: 0.6rem;\n\n  .order-date-filter{\n    display: flex;\n    align-items: center;\n    width: 50%;\n  }\n}\n\n.parts_textfield_dropdown {\n  width: 100%;\n}\n\n.search_partorderlist::placeholder {\n  font-family: \"Nunito\";\n  font-size: 16px;\n  font-weight: 400;\n\n}\n\n.partsorderfield_dropdown {\n  width: 50%;\n}\n\n.buttonsearch::placeholder {\n  font-family: \"Nunito\" !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  color: #A3AEC4 !important;\n}\n\n.multiselect_orderstatus {\n  width: 100%;\n  margin-left: 10px;\n}\n\n.multiselect_orderstatus fieldset {\n  border: 1px solid #a3aec4;\n  border-radius: 6px;\n}\n\n.multipleselect_order {\n  height: 2.5rem;\n  width: 160px !important;\n}\n\n.multiselect_orderinput {\n  min-width: 80% !important;\n}\n\n.button_search:disabled{\n  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n}\n\n@media screen and (max-width: 768px) {\n  .pgmtextfield_textfieldcontainers{\n    justify-content: flex-start !important;\n    flex-wrap: wrap;\n  }\n\n  .pgmtextfield_textfieldcontainers .order-date-filter{\n    width: 100% !important;\n  }\n\n  .multiSelect_orderlist{\n    width: 50%;\n  }\n\n  .multipleselect_order {\n    width: 95% !important;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .part_order_textfield {\n    display: flex;\n    // flex-direction: column;\n  }\n\n  .part_order_textfield .parts_textfield_dropdown .input-wrapper {\n    width: 100% !important;\n  }\n\n  .partlist_containers .button_search {\n    width: 95% !important;\n    margin: auto;\n  }\n\n  .multiSelect_orderlist, .partsorderfield_dropdown{\n    width: 100% !important;\n  }\n\n  .pgmtextfield_textfieldcontainers .order-date-filter{\n    width: 96% !important;\n  }\n\n  // .partsorderfield_dropdown {\n  //   width: 73%;\n  // }\n  // .multiSelect_orderStatus {\n  //   width: 97% !important;\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
